import * as types from '../constants/ActionTypes';
import initialState from './initialState';
import update from 'immutability-helper';
import _ from 'lodash';

export default function(state = initialState.contraventores, action) {
  switch (action.type) {
    case types.AGREGAR_CONTRAVENTOR: {
      // console.log("ESTOY EN AGREGAR CONTRAVENTOR: ");
      // console.log(action.payload);
      return update(state, { $push: [{ ...action.payload.contraventor }] });
    }

    case types.ELIMINAR_CONTRAVENTOR: {
      var col = state.map(value => Object.assign({}, value));
      // console.log("La coleccion es....: ",col);
      // console.log(_.remove(col,{_id:action.payload._id}));
      _.remove(col, { _id: action.payload._id });
      return col;
    }

    case types.PRUEBA_CONTRAVENTOR:
      return update(state, { $push: action.payload.contraventor });

    case types.SET_CONTRAVENTORES: {
      // console.log('Entre...');
      // console.log(action.payload);
      return update(state, { $set: action.payload.contraventores });
    }

    case types.GET_CONTRAVENTORES:
      return state;

    case types.REINICIAR:
      return initialState.contraventores;

    default:
      return state;
  }
}
